import Riyal from "@/components/ui/Riyal";

/** Price after the unit's discount (dashboard «خصم عام»), as the API sends it on cards. */
export type Discounted = {
  pricePerNight?: number;
  /** the struck-through price — only while the discount applies tonight */
  priceBeforeDiscount?: number;
  discount?: { percent: number; start?: string; end?: string; active?: boolean } | null;
};

const money = (n: number) => Number(n || 0).toLocaleString("en", { maximumFractionDigits: 2 });

/** "-30%" chip; nothing when the unit has no discount tonight. */
export function DiscountBadge({ p, className = "" }: { p: Discounted; className?: string }) {
  const pct = p.discount?.active ? p.discount.percent : 0;
  if (!pct) return null;
  return (
    <span dir="ltr" className={`inline-flex items-center rounded-full bg-red-600 px-2 py-0.5 text-[11px] font-extrabold text-white ${className}`}>
      -{pct}%
    </span>
  );
}

/** 495 ﷼ / night  ~~705~~  -30% */
export default function PriceTag({
  p,
  isAr,
  className = "",
  priceClassName = "text-clay-600 font-extrabold text-lg",
  showBadge = true,
}: {
  p: Discounted;
  isAr: boolean;
  className?: string;
  priceClassName?: string;
  showBadge?: boolean;
}) {
  const before = p.discount?.active ? Number(p.priceBeforeDiscount) || 0 : 0;
  return (
    <div className={`flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5 ${className}`}>
      <span className={priceClassName}>
        {money(p.pricePerNight ?? 0)} <Riyal />
      </span>
      <span className="text-sm font-normal text-ink-500">/ {isAr ? "ليلة" : "night"}</span>
      {before > 0 && (
        <span className="text-sm font-semibold text-ink-500 line-through decoration-red-500/70">
          {money(before)}
        </span>
      )}
      {showBadge && <DiscountBadge p={p} className="self-center" />}
    </div>
  );
}
